const getExcerpt = ({text, characters = 340}) => {
  const subString = text.substr(0, characters - 1)
  return subString
    .substr(0, subString.lastIndexOf(" "))
    .replace(/<\/?[^>]+(>|$)/g, "")
}

// eslint-disable-next-line import/prefer-default-export
export { getExcerpt }
